"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayConfig = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const ModelCommon_1 = require("../ModelCommon");
const typeName = 'GatewayConfig';
class GatewayConfig extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(typeName, { ...ob, type: ob.type ?? typeName });
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            crt: { type: 'String', editable: false, label: 'Gateway Cert', valueFn: () => this.AWS_LPWAN?.cupsInfo.crt },
            key: { type: 'String', editable: false, label: 'Key', valueFn: () => this.AWS_LPWAN?.cupsInfo.key },
            trust: { type: 'String', editable: false, label: 'Trust Cert', valueFn: () => this.AWS_LPWAN?.cupsInfo.key },
            uri: { type: 'String', editable: false, label: 'LNS URI', valueFn: () => this.AWS_LPWAN?.cupsInfo.uri },
        };
    }
}
exports.GatewayConfig = GatewayConfig;
GatewayConfig.getGatewayConfigKeys = (gateway) => (0, iotv_v3_types_1.getZombieInstanceFromPrimaryKey)(`${typeName}:${gateway.id}`, { pk: gateway.sk });
